export const HOMEPAGE_REQUEST = "HOMEPAGE_REQUEST";
export const HOMEPAGE_RECEIVE = "HOMEPAGE_RECEIVE";
export const HOMEPAGE_FAILURE = "HOMEPAGE_FAILURE";
export const RESET_HOMEPAGE = "RESET_HOMEPAGE";